const API_BASE_URL = process.env.REACT_APP_API_URL;

if (!API_BASE_URL) {
  throw new Error('REACT_APP_API_URL environment variable is not set');
}

// Wraps fetch() so every request to the API automatically sends the
// HttpOnly auth cookie (credentials: 'include'). This replaces manually
// attaching an Authorization header pulled from localStorage - the cookie
// is invisible to page JS, so it can't be read by an XSS payload.
function apiFetch(url, options = {}) {
  return fetch(url, { ...options, credentials: 'include' });
}

export { API_BASE_URL, apiFetch };